import { render, staticRenderFns } from "./internalImprovementDetail.vue?vue&type=template&id=ba8ee75e"
import script from "./internalImprovementDetail.vue?vue&type=script&lang=js"
export * from "./internalImprovementDetail.vue?vue&type=script&lang=js"
import style0 from "./internalImprovementDetail.vue?vue&type=style&index=0&id=ba8ee75e&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba8ee75e')) {
      api.createRecord('ba8ee75e', component.options)
    } else {
      api.reload('ba8ee75e', component.options)
    }
    module.hot.accept("./internalImprovementDetail.vue?vue&type=template&id=ba8ee75e", function () {
      api.rerender('ba8ee75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/internalImprovementDetail.vue"
export default component.exports